/**
 * Created by noOne on 17/08/2017.
 */

"use strict";

import Common from "./Common";
import Entity3D from "./Entity3D";
import Camera from "./Camera";
import Motive3D from "./Motive3D";
import SpriteRenderer from "./SpriteRenderer";

export default class Player extends Entity3D {
    constructor(map) {
        super();

        /**
         * @type {Map}
         * @private
         */
        this._map = map;

        /**
         * @type {Camera}
         * @private
         */
        this._camera = new Camera(map, this);

        /**
         * Players world position
         * @type {PIXI.Point}
         * @private
         */
        this._position = new PIXI.Point(1.5, 1.5);

        /**
         * Player / Camera facing direction
         * @type {PIXI.Point}
         * @private
         */
        this._dir = this._camera.direction;

        /**
         * @type {number}
         * @private
         */
        this._moveSpeed = 0.08;// * 2;

        /**
         * @type {number}
         * @private
         */
        this._rotSpeed = 0.04;// * 2;

        /**
         * @type {number}
         * @private
         */
        this._yAdjust = 1;

        /**
         * @type {{}}
         * @private
         */
        this._moveFor = Common.keyboard(87);

        /**
         * @type {{}}
         * @private
         */
        this._moveBk = Common.keyboard(83);

        /**
         * @type {{}}
         * @private
         */
        this._rotL = Common.keyboard(65);

        /**
         * @type {{}}
         * @private
         */
        this._rotR = Common.keyboard(68);

        /**
         * @type {{}}
         * @private
         */
        this._shoot = Common.keyboard(32);
        this._shoot.down = ()=> this.shoot();

        // this._jump = Common.keyboard(32);
        //  this._jump.down = ()=> {
        //yAdjust 1 is jumping such that eye is parallel with top of wall (hit head on ceiling)
        //   TweenMax.to(this, 0.5, {yAdjust: 0, yoyo: true, repeat: 1, ease: Power1.easeOut});
        //  };

        this._crouch = Common.keyboard(16);
        this._crouch.down = ()=> {
            //yAdjust 2 is on the floor (like an ant), 1.5 would be as if you crouched to half your height.
            TweenMax.to(this, 0.5, {yAdjust: 1.5, ease: Power0.easeNone});
        };
        this._crouch.up = ()=> {
            TweenMax.to(this, 0.5, {yAdjust: 1, ease: Power0.easeNone});
        };

        //--rotate to desired start rotation--//
        this.rotate(Math.PI);

        this._path = this._map.playerPath;

        // this.followPath();
    }

    start() {
        this._camera.update();
    }

    shoot(pos) {
        //return;
        pos = pos || new PIXI.Point(P3.View.width * 0.5);
        const hitBuffer = this._camera.hitBuffer;
        const target = hitBuffer[Math.floor(pos.x)];
        const projectile = new Motive3D("magic_ball");
        projectile.x = this.x;
        projectile.y = this.y;
        const filter = new SpriteRenderer();
        projectile.view.filters = [filter];
        projectile.filter = filter;
        Common.sprites.push(projectile);
        Common.projectiles.push(projectile);
        Common.spriteHolder.addChild(projectile.view);
        projectile.BEHAVE_MOVETO(target);
        projectile.view.alpha = 0;
        TweenMax.to(projectile.view, 0.15, {alpha: 1, ease: Power2.easeIn});
    }

    //todo? - collide with sprites (at least big sprites would need collision)
    update() {
        //--take user input--//
        const map = this._map.grid;
        let updateRender = false; //no need to recalculate ray casting every frame, can just update for frames that changed
        //--walk around--//
        if (this._moveFor.isDown) {
            /*
             //check for collision
             if (map[Math.floor(this.x + this.dirX * this._moveSpeed * 4)] &&
             map[Math.floor(this.x + this.dirX * this._moveSpeed * 4)][Math.floor(this.y)] === 0) {
             this.x += this.dirX * this._moveSpeed;
             }
             if (map[Math.floor(this.x)][Math.floor(this.y + this.dirY * this._moveSpeed * 4)] === 0) {
             this.y += this.dirY * this._moveSpeed;
             }
             updateRender = true;
             */
        }//--
        if (this._moveBk.isDown && !this._rotL.isDown && !this._rotR.isDown) {
            /*
             if (map[Math.round(this.x - this.dirX * this._moveSpeed * 4)] &&
             map[Math.round(this.x - this.dirX * this._moveSpeed * 4)][Math.round(this.y)] === 0) {
             this.x -= this.dirX * this._moveSpeed;
             }
             if (map[Math.round(this.x)][Math.round(this.y - this.dirY * this._moveSpeed * 6)] === 0) {
             this.y -= this.dirY * this._moveSpeed;
             }
             updateRender = true;
             */
        }
        //--rotate player--//
        if (this._rotL.isDown) {
            //this.rotate(this._rotSpeed);
            // updateRender = true;
        }
        if (this._rotR.isDown) {
            //  this.rotate(-this._rotSpeed);
            //  updateRender = true;
        }

        // if (updateRender) { //commented out so can update sprites even when player not moving
        //--update camera (render world)--//
        this._camera.update();
        //  }
    }

    rotate(angle) {
        //both camera direction and camera plane must be rotated
        let oldDirX = this.dirX;
        this.dirX = this.dirX * Math.cos(angle) - this.dirY * Math.sin(angle);
        this.dirY = oldDirX * Math.sin(angle) + this.dirY * Math.cos(angle);

        let plane = Common.plane;
        let oldPlaneX = plane.x;
        plane.x = plane.x * Math.cos(angle) - plane.y * Math.sin(angle);
        plane.y = oldPlaneX * Math.sin(angle) + plane.y * Math.cos(angle);
    }

    moveTo(pos, cb) {
        //calc distance for time calculations
        const speed = 4;
        const d = Common.distance(this.x, this.y, pos.x, pos.y);
        const t = d / speed;

        TweenMax.to(this, t, {
            x: pos.x,
            y: pos.y,
            ease: Power0.easeNone,
            onComplete: cb
        });
    }

    rotateTo(angle, cb) {
        /*
         //  this.dirX = this.dirX * Math.cos(angle) - this.dirY * Math.sin(angle);
         //this.dirY = oldDirX * Math.sin(angle) + this.dirY * Math.cos(angle);
         console.log("doing rotate");
         const dirTargX = this.dirX * Math.cos(angle) - this.dirY * Math.sin(angle);
         const dirTargY = this.dirX * Math.sin(angle) + this.dirY * Math.cos(angle);
         TweenMax.to(this, 1, {dirX: dirTargX, dirY: dirTargY, ease: Power0.easeNone});

         const plane = Common.plane;
         // let oldPlaneX = plane.x;
         const planeTargX = plane.x * Math.cos(angle) - plane.y * Math.sin(angle);
         const planeTargY = plane.x * Math.sin(angle) + plane.y * Math.cos(angle);
         TweenMax.to(plane, 1, {x: planeTargX, y: planeTargY, ease: Power0.easeNone, onComplete: cb});
         */

        const time = 0.25;//--ms
        const len = 10;
        const interval = time / len;
        const angularSlice = angle / len;

        let count = 0;

        // console.log("doing rotate");
        // console.log(angle);
        //this.rotate(angle);
        // delay(cb, 0.5, this);

        var rotating = () => {
            if (count < len) {
                this.rotate(angularSlice);
                count++;
                delay(rotating, interval, this);
            } else {
                cb();
            }
        };
        rotating();

    }

    followPath() {

        var cb = ()=> {
            this._path.pop();
            if (this._path.length > 0) this.followPath();
        };

        const target = this._path[this._path.length - 1];
        if (target.type === "move") {
            console.log("moving player");
            this.moveTo(target, cb);
        } else if (target.type === "rotate") {
            console.log("rotating player");
            this.rotateTo(target.angle, cb);
        }
    }

    get yAdjust() {
        return this._yAdjust;
    }

    set yAdjust(val) {
        this._yAdjust = val;
    }
}
